import { Component, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-general-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-general-checkbox.component.html',
})
export class InputGeneralCheckboxComponent {
  private translate = inject(TranslateService);

  formControlGeneral = input<FormControl | null>(new FormControl());
  label = input('');
  options = input<{ value: string | number; label: string }[]>([]);

  get getInputGeneral(): FormControl {
    return this.formControlGeneral() as FormControl;
  }

  isRequired(): boolean {
    return !!this.formControlGeneral()?.hasValidator?.(Validators.required);
  }

  hasErrorState(): boolean {
    const ctrl = this.formControlGeneral();
    return !!ctrl && ctrl.invalid && (ctrl.touched || ctrl.dirty);
  }

  isChecked(value: string | number): boolean {
    const ctrl = this.formControlGeneral();
    if (!ctrl || !ctrl.value) return false;
    return Array.isArray(ctrl.value) && ctrl.value.includes(value);
  }

  onCheckboxChange(value: string | number, checked: boolean): void {
    const ctrl = this.getInputGeneral;
    if (!ctrl) return;

    let currentValue: (string | number)[] = Array.isArray(ctrl.value) ? [...ctrl.value] : [];

    if (checked) {
      if (!currentValue.includes(value)) {
        currentValue.push(value);
      }
    } else {
      currentValue = currentValue.filter(v => v !== value);
    }

    ctrl.setValue(currentValue);
  }

  getErrorMessage(): string {
    const control = this.formControlGeneral();
    if (!control || !control.errors) return '';

    if (control.errors['required']) {
      return this.translate.instant('inputs.required');
    }

    return '';
  }
}
